import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import { NavLink } from 'react-router-dom';

export default class CSR extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            loading: true,
            name: '',
            name_en: '',
            nationalId: '',
            personType: 2,
            csr: '',
            private_key: '',
            public_key: '',
            email: ''
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/common/get", {
            id: this.getCurrentFormId()
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.setState({
                    data: data,
                    loading: false
                })
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    save(e) {
        e.preventDefault();
        this.httpPost("api/v1/csr/create", {
            nationalId: this.state.nationalId,
            name: this.state.name,
            name_en: this.state.name_en,
            email: this.state.email,
            personType: this.state.personType,
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.showSuccessMessage("کلیدها با موفقیت ایجاد شد");
                this.setState({
                    csr: data.csr,
                    private_key: data.private_key,
                    public_key: data.public_key,
                })
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    renderForm() {
        return <form method="post" onSubmit={e => this.save(e)} className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            <div className="nk-content-body">
                                <div className="components-preview wide-md mx-auto">
                                    <div className="nk-block-head nk-block-head-lg wide-sm">
                                        <div className="nk-block-head-content">
                                            <div className="nk-block-head-sub">
                                                <NavLink className="back-to" to="/companies/"><em className="icon ni ni-arrow-left"></em><span>ساخت کلید و گواهی CSR</span></NavLink>
                                             </div>
                                        </div>
                                    </div>
									<div className="nk-block nk-block-lg">
                                        <div className="card card-bordered">
                                            <div className="card-inner">
                                                <div className="tab-content">
                                                    <div className="tab-pane active" id="base">
                                                <div className="row g-4">
                                                        <div className="col-lg-2">
                                                            <div className="form-group">
                                                                <label className="form-label">نوع مودی</label>
                                                            <div className="form-control-wrap">
                                                                <select className="form-control" defaultValue={this.state.personType} onChange={e => this.setState({ personType: parseInt(e.target.value) })}>
                                                                        <option value="2">حقوقی</option>
                                                                        <option value="1">حقیقی</option>
                                                                    </select>
                                                                </div>
                                                        </div>
                                                    </div>
                                                            <div className="col-lg-5">
                                                                <div className="form-group">
                                                                {this.state.personType === 1 && <label className="form-label">نام کامل شخص به فارسی</label>}
                                                                {this.state.personType === 2 && <label className="form-label">نام کامل شرکت به فارسی</label>}
                                                                    <div className="form-control-wrap">
                                                                        <input className="form-control" type="text" defaultValue={this.state.name} onChange={e => this.state.name = e.target.value} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-5">
                                                            <div className="form-group">
                                                                {this.state.personType === 1 && <label className="form-label">نام کامل شخص به انگلیسی</label>}
                                                                {this.state.personType === 2 && <label className="form-label">نام کامل شرکت به انگلیسی</label>}
                                                                    <div className="form-control-wrap">
                                                                        <input className="form-control ltr" type="text" defaultValue={this.state.name_en} onChange={e => this.state.name_en = e.target.value} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-3">
                                                                <div className="form-group">
                                                                {this.state.personType === 1 && <label className="form-label">کد ملی</label>}
                                                                {this.state.personType === 2 && <label className="form-label">شناسه ملی</label>}
                                                                    <div className="form-control-wrap">
                                                                <input className="form-control ltr"  type="text" defaultValue={this.state.nationalId} onChange={e => this.state.nationalId = e.target.value} />
                                                                    </div>
                                                                </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="form-group">
                                                                <label className="form-label">پست الکترونیکی</label>
                                                                <div className="form-control-wrap">
                                                                    <input className="form-control ltr" maxLength="150" type="text" defaultValue={this.state.email} onChange={e => this.state.email = e.target.value} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                            <div className="col-lg-12">
                                                                <div className="form-group">
                                                                    <button type="submit" className="btn btn-lg btn-primary">تولید</button>
                                                                </div>
                                                    </div>
                                                    {!this.isBlank(this.state.csr) && < div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label className="form-label">گواهی CSR</label>
                                                            <div className="form-control-wrap">
                                                                <textarea defaultValue={this.state.csr} className="ltr form-control" readOnly="true" style={{ height: "200px" }}></textarea>
                                                            </div>
                                                            <a style={{"margin-top": "15px"}} onClick={e => this.downloadText(this.state.csr, "Certificate.txt")} type="submit" className="btn btn-sm btn-primary">دریافت فایل گواهی CSR</a>
                                                        </div>
                                                    </div>}
                                                    {!this.isBlank(this.state.private_key) && <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className="form-label">کلید خصوصی</label>
                                                            <div className="form-control-wrap">
                                                                <textarea defaultValue={this.state.private_key} className="ltr form-control" readOnly="true" style={{ height: "200px" }}></textarea>
                                                            </div>
                                                            <a style={{ "margin-top": "15px" }} onClick={e => this.downloadText(this.state.private_key, "PrivateKey.txt")} type="submit" className="btn btn-sm btn-primary">دریافت فایل کلید خصوصی</a>
                                                        </div>
                                                    </div>}
                                                    {!this.isBlank(this.state.public_key) && <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className="form-label">کلید عمومی</label>
                                                            <div className="form-control-wrap">
                                                                <textarea defaultValue={this.state.public_key} className="ltr form-control" readOnly="true" style={{ height: "200px" }}></textarea>
                                                            </div>
                                                            <a style={{ "margin-top": "15px" }} onClick={e => this.downloadText(this.state.public_key,"PublicKey.txt")} type="submit" className="btn btn-sm btn-primary">دریافت فایل کلید عمومی</a>
                                                        </div>
                                                    </div>}
                                                    {!this.isBlank(this.state.public_key) && <a href="https://tp.tax.gov.ir" target="_blank">لینک دریافت شناسه حافظه مالیاتی</a>}
                                                        </div>
                                            </div>


                                        </div>
                                        <div class="example-alert">
                                            <div class="alert alert-warning alert-icon">
                                                <em class="icon ni ni-alert-circle"></em>
                                                برای دریافت شناسه یکتا کافیست کلید عمومی رو در کارپوشه مودیان مالیاتی بارگذاری نمایید سپس شناسه یکتا را در سامانه سپهر قسمت مدیریت مودی بارگذاری  وارد نمایید
                                            </div>
                                        </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() : 
                    [
                        this.state.lockScreen === 1 && this.lockScreen(),
                        <Header data={this.state.data} />,
                        <div className="nk-content ">
                            <div className="container-fluid">
                                <div className="nk-content-inner">
                                    {this.renderForm()}
                                </div>
                            </div>
                        </div>,
                        <Footer />
                    ];

        return contents;
    }
}